import Subsection from "./Subsection";
import SubsectionFooter from "./SubsectionFooter";
import SubsectionHeader from "./SubsectionHeader";
import SubsectionHeaderContent from "./SubsectionHeaderContent";

export default Subsection;
export {
  Subsection,
  SubsectionFooter,
  SubsectionHeader,
  SubsectionHeaderContent,
};
